<template>
  <div>
    <van-action-sheet v-model:show="showAll" title="协议" class="showAll">
      <van-cell v-for="item in contractList" :key="item.url" :title="`《${item.name}》`" is-link  @click="showClick(item)"/>
      <div class="box-btn">
        <Button type="danger" text="我已阅读并同意以上内容" class="nextStep" :click="clickAgreeAll"/>
      </div>
    </van-action-sheet>
    <van-popup
      v-model="show"
      round
      class="inPop"
    >
    <div id="container">
      <div class="crossBox"><van-icon @click="hidePopup" class="cross" name="cross" /></div>
      <div style="text-align: left;" class="clause">
      <!-- 添加 iframe 来展示协议内容 -->
      <iframe v-if="contract" :src="contract.url" style="width: 100%; height: 100%; border: none;"></iframe>
      </div>
    </div>
    </van-popup>
    <div class="agreement">
      <img
        class="selectImg"
        @click="clickAgree()"
        :src="imgUrlAgreement"
        alt=""
      >
      <span
        class="agreementText"
        @click="clickAgree()"
      >{{text}}</span>
      <!-- <br/> -->
      <span
        class="agreement_content"
        @click="expandAll()"
      >《{{contractList[0]?.name}}》等协议</span>
      <!-- <span
        class="agreement_content"
        @click="showClick(item.value)"
        v-for="item in list"
        :key="item.value"
      >《{{ item.text }}》</span> -->
      
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import NoSelect from '@/assets/images/weixuanzhong.png';
import Button from '@/components/Button.vue';
import Select from '@/assets/images/xuanzhong.png';
export default {
  name: 'ContractFold',
  props: {
    api: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '本人已经阅读并完全同意：',
    },
    isForceRead: {
      default: '',
    },
    counts: {
      default: 5,
    },
    value: Boolean,
    defaultCheck: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      contractList: [],
      forceRead: false,
      agreeWithAgreement: this.defaultCheck,
      contract: null,
      show: false,
      showAll: false,
      imgUrlAgreement: this.defaultCheck ? Select : NoSelect,
    };
  },

  components: {
    Button
  },
  mounted() {
    if (this.api) {
      axios.get(this.api)
        .then(response => {
          const res = response.data;
          if (res.data&&res.data.result=='S'&&res.data.contractList) {
            this.contractList = res.data.contractList;
          }
        })
        .catch(error => {
          console.error('请求接口失败:', error);
        });
    }
  },
  methods: {
    expandAll() {
      this.showAll = !this.showAll;
    },
    clickAgreeAll() {
      this.showAll = false;
      this.agreeWithAgreement = true;
      this.imgUrlAgreement = this.agreeWithAgreement? Select : NoSelect;
      this.$emit('input', this.agreeWithAgreement);
    },
    clickAgree() {
        if(!this.agreeWithAgreement) {
          this.expandAll()
        }else{
          this.agreeWithAgreement = !this.agreeWithAgreement;
          this.imgUrlAgreement = this.agreeWithAgreement ? Select : NoSelect;
          this.$emit('input', this.agreeWithAgreement);
        }
    },
    showClick(val) {
      // this.$emit('showPopup', this.agreeMap[val]);
      this.showPopup(val);
    },
    showPopup(val) {
      this.contract = val;
      this.show = !this.show;
    },
    hidePopup() {
      this.show = !this.show;
    },
  },
};
</script>
<style scoped>
.inPop {
  width: 90%;
  height: 90%;
  padding: 10px;
}
.showAll{
  text-align: left;
}
/* .showAll >>> .van-action-sheet__content {
  margin-bottom: 60px;
} */
.box-btn{
  /* border-top: 1px solid #ccc;
  position: absolute;
  width: 100%;
  bottom: 0; */
  padding: 8px 0;
}
.forceRead {
  padding-bottom: 50px;
  overflow: hidden;
}
.forceReadBtn {
  background: #ff6538;
  color: #fff;
  border-radius: 4px;
  padding: 8px;
  text-align: center;
}
.disable {
  background: #d7d7d7;
}

.inPop >>> .inPop a#close {
  background: none;
  color: #000;
}

.agreement {
  box-sizing: border-box;
  margin-top: 10px;
  margin: 0 15px 0 15px;
  color: #9ea7b4;
  font-size: 12px;
  line-height: 24px;
  letter-spacing: 0;
  text-align: left;
  position: relative;
}
.agreement .agreement_content {
  color: #ff6538;
}
.selectImg {
  width: 12px;
  position: absolute;
  top: 5px;
  left: 0;
}
.seletedColor {
  color: #ff6538;
}
.agreementText {
  margin-left: 20px;
}

.crossBox {
  text-align: right;
}
.cross {
  font-size: 20px;
}
#container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.clause {
  flex: 1;
  background: #fff;
  background-size: contain;
}
</style>
